var _path, _path2, _rect, _path3, _rect2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFbMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.466 4.444H8.653a4.208 4.208 0 00-4.209 4.209v22.813a4.208 4.208 0 004.209 4.208h11.25l.02-11.16h-2.9a.684.684 0 01-.683-.681l-.014-3.597a.684.684 0 01.684-.687h2.894v-3.476c0-4.034 2.464-6.23 6.062-6.23h2.953c.377 0 .684.306.684.684v3.033a.684.684 0 01-.684.684l-1.812.001c-1.957 0-2.336.93-2.336 2.295v3.009h4.3c.41 0 .728.358.68.765l-.427 3.597a.684.684 0 01-.68.604H24.79l-.019 11.16h6.695a4.208 4.208 0 004.208-4.209V8.653a4.208 4.208 0 00-4.208-4.209z",
    fill: "url(#fb-message_svg__paint0_linear_3841_67333)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.466 4.444H8.653a4.208 4.208 0 00-4.209 4.209v22.813a4.208 4.208 0 004.209 4.208h11.25l.02-11.16h-2.9a.684.684 0 01-.683-.681l-.014-3.597a.684.684 0 01.684-.687h2.894v-3.476c0-4.034 2.464-6.23 6.062-6.23h2.953c.377 0 .684.306.684.684v3.033a.684.684 0 01-.684.684l-1.812.001c-1.957 0-2.336.93-2.336 2.295v3.009h4.3c.41 0 .728.358.68.765l-.427 3.597a.684.684 0 01-.68.604H24.79l-.019 11.16h6.695a4.208 4.208 0 004.208-4.209V8.653a4.208 4.208 0 00-4.208-4.209z",
    fill: "url(#fb-message_svg__paint1_linear_3841_67333)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2F54EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.024 30.204a6.026 6.026 0 00-2.274-4.312 6.049 6.049 0 00-4.73-1.2c-2.986.517-5.177 3.28-4.968 6.321.098 1.465.415 2.643 1.448 3.676-.265.39-.5 1-1.385 1.878a.38.38 0 00-.14.405c.029.153.14.279.28.32.209.07.516.098.865.098.74 0 2.225-.726 2.95-1.102a5.967 5.967 0 003.015.237c2.986-.53 5.149-3.307 4.94-6.321zm-8.777 1.493a.97.97 0 01-.976-.977.97.97 0 01.976-.977.97.97 0 01.977.977.97.97 0 01-.977.977zm2.791 0a.97.97 0 01-.977-.977.97.97 0 01.977-.977.97.97 0 01.977.977.97.97 0 01-.977.977zm2.791 0a.97.97 0 01-.977-.977.97.97 0 01.977-.977.97.97 0 01.977.977.97.97 0 01-.977.977z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#fff",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb-message_svg__paint0_linear_3841_67333",
    x1: 36.297,
    y1: 4.731,
    x2: 4.737,
    y2: 36.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb-message_svg__paint1_linear_3841_67333",
    x1: 35.605,
    y1: 4.514,
    x2: 4.513,
    y2: 35.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#4867AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7295E1"
  })))));
}

export default __webpack_public_path__ + "./fonts/fb-message.88b5bd121ed744e74ed4cd7312ce950e.svg";
export { SvgFbMessage as ReactComponent };